import React from 'react';
import {useNavigate} from 'react-router';

import AccountHeaderIcon from '../img/account-header.svg';
import MyAccountDetails from '../Account/MyAccountDetails';
import {useAuth} from '../Auth/useAuth';
import AccountItem from '../Account/AccountItem';
import MyAccountCookieToggle from '../Util/MyAccountCookieToggle';
import InvitationSection from './Invitations/InvitationSection';

const ProAccount = () => {
  const {authState} = useAuth();
  const navigate = useNavigate();
  const hasLoaded = authState.user.id !== undefined;
  const profile = authState.user.profile;

  return hasLoaded ? (
    <div data-testid="pro-account">
      {/* Rendered locally rather than through `Util/PageHeader`: that file is
          MUI and its other consumers belong to other migration tickets, so
          COM-162's precedent of leaving it whole applies here too. */}
      <header className="bg-(--compass-primary) pb-8 text-(--compass-on-primary)">
        <div className="mx-auto w-full max-w-[900px] px-4 pt-6">
          <div className="flex items-center justify-between">
            <h1 className="w-4/5 text-3xl font-bold sm:w-3/5">My Account</h1>
            <img aria-hidden="true" src={AccountHeaderIcon} height={90} width={90} alt="" />
          </div>
        </div>
      </header>
      <div className="mx-auto w-full max-w-[900px] px-4 py-12">
        <p className="mb-4">
          Here is all the personal information you shared with Compass when you signed up. You can
          change this at any time.
        </p>
        <div className="mb-6">
          <h2 className="mb-2 text-2xl font-bold">My Information</h2>
          <MyAccountDetails user={authState.user} />
        </div>
        {profile ? (
          <>
            <div className="mb-6" data-testid="pro-account-profile">
              <h2 className="mb-2 text-2xl font-bold">My Professional Profile</h2>
              <AccountItem heading="Job Title:" onClick={() => navigate('edit/job-title')}>
                <span className="block">{profile.job_title || 'Not specified'}</span>
              </AccountItem>
              <AccountItem heading="Sector:" onClick={() => navigate('edit/sector')}>
                <span className="block">{profile.sector?.name || 'Not specified'}</span>
              </AccountItem>
              <AccountItem heading="Area:" onClick={() => navigate('edit/area')}>
                <span className="block">
                  {profile.local_authority_id && profile.local_authority
                    ? profile.local_authority.name
                    : profile.health_board_area_id && profile.health_board_area
                    ? profile.health_board_area.name
                    : profile.national_scotland
                    ? 'National (Scotland)'
                    : 'Outside Scotland'}
                </span>
              </AccountItem>
            </div>
            {/* Invitations are a COM-164 non-goal and this section is still
                MUI-adjacent; the AC11 carve-out is recorded in the roadmap. */}
            <div className="mb-6">
              <InvitationSection />
            </div>
          </>
        ) : (
          <p role="status">Loading…</p>
        )}
        <MyAccountCookieToggle />
      </div>
    </div>
  ) : null;
};

export default ProAccount;
